import React from 'react';

export const IconViews = (
  <svg aria-label="Icon Views" width="1em" height="1em" viewBox="0 0 24 24">
    <path fill="currentColor" fillRule="nonzero" d="M22.37 11.1a12.036 12.036 0 0 0-10.388-5.894A12.036 12.036 0 0 0 1.593 11.1a1.772 1.772 0 0 0 0 1.8 12.036 12.036 0 0 0 10.389 5.894c4.425 0 8.307-2.363 10.388-5.894a1.772 1.772 0 0 0 0-1.8zm-10.388 5.922c-3.787 0-7.093-2.02-8.862-5.022a10.249 10.249 0 0 1 7.981-4.985 2.068 2.068 0 1 1-3.55 1.44v-.001a5.022 5.022 0 1 0 8.422-.682A10.212 10.212 0 0 1 20.843 12a10.261 10.261 0 0 1-8.861 5.022z" />
  </svg>
);
